// extracted by mini-css-extract-plugin
module.exports = {"langSwitch":"PasswordRecoveryForm_langSwitch__12ulO"};